export const isDev = (): boolean => process.env.NODE_ENV === 'development';
